export const keys = {
  user: (uid: string | null) => ["user", uid] as const,
  synch: (uid: string | null) => ["synch", uid] as const,
  activities: (uid: string | null) => ["activities", uid] as const,
  activity: (id: string) => ["activity", id] as const,
  samples: (id: string) => ["activity", id, "samples"] as const,
  laps: (id: string) => ["activity", id, "laps"] as const,
  coords: (id: string) => ["activity", id, "coords"] as const,
  annual: (uid: string | null) => ["annual", uid] as const,
  totals: (uid: string | null) => ["totals", uid] as const,
  tvDevices: (uid: string | null) => ["tv", uid] as const,
  tags: (uid: string | null) => ["tags", uid] as const,
  apiTokens: (uid: string | null) => ["api-tokens", uid] as const,
};
